import { useEffect, useRef, useState } from 'react'
import NumberFormat from 'react-number-format'
import { Input } from 'reactstrap'

const BasicSumAssured = ({ isReadOnly, sumAssured, enabled, editSumAssured }) => {
  const [localSumAssured, setLocalSumAssured] = useState(sumAssured)
  const isFocusedRef = useRef(false)

  useEffect(() => {
    if (!isFocusedRef.current) {
      setLocalSumAssured(sumAssured)
    }
  }, [sumAssured])

  if (enabled) {
    return (
      <NumberFormat
        id="sum-assured-input"
        disabled={Boolean(isReadOnly)}
        isAllowed={({ formattedValue }) => formattedValue.length <= 17}
        customInput={Input}
        value={localSumAssured}
        thousandSeparator={true}
        allowNegative={false}
        type="tel"
        pattern="[0-9]*"
        onFocus={(e) => {
          isFocusedRef.current = true
          e.target.setSelectionRange(0, -1)
        }}
        onBlur={() => {
          isFocusedRef.current = false
          setLocalSumAssured(sumAssured)
        }}
        onChange={(e, values) => {
          const nextValue = Number(values.value)
          setLocalSumAssured(nextValue)
          editSumAssured(nextValue)
        }}
      />
    )
  } else {
    return <Input id="sum-assured-input" value="-" disabled={true} />
  }
}

//const mapStateToProps = (state: AppState) => ({
//  sumAssured$: getSumAssured$(state),
//  haveBasicPremiumState: haveBasicPremiumState(state),

export default BasicSumAssured
